import { useRef, useState } from "react";
import { Plus, Camera, Spinner } from "@phosphor-icons/react";
import { uploadImage } from "../../lib/merchantApi";
import { toast } from "sonner";

export const ImagePicker = ({ kind = "logo", label, hint, value, onChange, testid }) => {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const isLogo = kind === "logo";

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!["image/jpeg", "image/png", "image/webp"].includes(file.type)) {
      toast.error("Formato não suportado (use JPG, PNG ou WebP)");
      return;
    }
    if (file.size > 3 * 1024 * 1024) {
      toast.error("Arquivo muito grande (máx 3 MB)");
      return;
    }
    setUploading(true);
    try {
      const { url } = await uploadImage(file);
      onChange(url);
      toast.success("Imagem enviada!");
    } catch (err) {
      toast.error(err.message || "Falha no upload");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <button
      type="button"
      data-testid={testid}
      onClick={() => inputRef.current?.click()}
      className={`relative flex items-center justify-center overflow-hidden rounded-2xl border-2 border-dashed border-maraca-amber bg-slate-50 transition-colors hover:bg-slate-100 ${
        isLogo ? "h-28 w-28 shrink-0" : "h-40 w-full"
      }`}
    >
      <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" onChange={handleFile} className="hidden" />
      {uploading ? (
        <Spinner size={26} className="animate-spin text-maraca-amber" />
      ) : value ? (
        <>
          <img src={value} alt={label} className="absolute inset-0 h-full w-full object-cover" />
          <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-full bg-maraca-amber px-2.5 py-1 text-xs font-bold text-white shadow">
            <Camera size={13} weight="fill" /> Trocar
          </span>
        </>
      ) : (
        <span className="flex flex-col items-center gap-2 px-2 text-center">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-maraca-amber text-white shadow">
            <Plus size={22} weight="bold" />
          </span>
          <span className="text-sm font-bold text-maraca-amber">{label}</span>
          {hint && <span className="text-[11px] text-maraca-navy/50">{hint}</span>}
        </span>
      )}
    </button>
  );
};
